// src/fonts/index.ts
var FONT_MAP = {
  woff2: { format: "woff2", mime: "font/woff2" },
  woff: { format: "woff", mime: "font/woff" },
  opentype: { format: "opentype", mime: "font/otf" },
  otf: { format: "opentype", mime: "font/otf" },
  ttf: { format: "truetype", mime: "font/ttf" },
  truetype: { format: "truetype", mime: "font/ttf" },
  sfnt: { format: "truetype", mime: "font/ttf" }
};
var findFontEntry = (contentType, url) => {
  if (contentType) {
    for (const [key, entry] of Object.entries(FONT_MAP)) {
      if (contentType.includes(key)) return entry;
    }
  }
  if (url) {
    const path = url.split("?")[0].toLowerCase();
    for (const [ext, entry] of Object.entries(FONT_MAP)) {
      if (path.endsWith(`.${ext}`)) return entry;
    }
  }
  return null;
};
var isFontAsset = (contentType, url) => {
  if (contentType == null ? void 0 : contentType.startsWith("font/")) return true;
  if (contentType === "application/x-font-ttf" || contentType === "application/x-font-opentype")
    return true;
  return !!findFontEntry(void 0, url);
};
var getFontFormat = (contentType, url) => {
  var _a;
  return ((_a = findFontEntry(contentType, url)) == null ? void 0 : _a.format) ?? null;
};
var getFontMimeType = (contentType, url) => {
  var _a;
  return ((_a = findFontEntry(contentType, url)) == null ? void 0 : _a.mime) ?? "font/ttf";
};
var DEFAULT_FONT_FAMILY = "sans-serif";
var generateThemeFontStyles = (options) => {
  const { font, bodyFont, scope, headingSelector } = options;
  const validDisplayFont = (font == null ? void 0 : font.url) && isFontAsset(font.contentType, font.url) ? font : null;
  const validBodyFont = (bodyFont == null ? void 0 : bodyFont.url) && isFontAsset(bodyFont.contentType, bodyFont.url) ? bodyFont : null;
  const empty = {
    fontFaceCss: "",
    fontFamily: void 0,
    displayFontFamily: void 0,
    bodyFontFamily: void 0,
    fontsToPreload: []
  };
  if (!validDisplayFont && !validBodyFont) return empty;
  const displayName = `${scope}-display-font`;
  const bodyName = `${scope}-body-font`;
  const displayFormat = getFontFormat(validDisplayFont == null ? void 0 : validDisplayFont.contentType, validDisplayFont == null ? void 0 : validDisplayFont.url);
  const bodyFormat = getFontFormat(validBodyFont == null ? void 0 : validBodyFont.contentType, validBodyFont == null ? void 0 : validBodyFont.url);
  const displayFace = validDisplayFont && displayFormat ? `@font-face {
          font-family: '${displayName}';
          src: url('${validDisplayFont.url}') format('${displayFormat}');
          font-display: swap;
        }` : "";
  const bodyFace = validBodyFont && bodyFormat ? `@font-face {
          font-family: '${bodyName}';
          src: url('${validBodyFont.url}') format('${bodyFormat}');
          font-display: swap;
        }` : "";
  const headingRule = validDisplayFont && displayFormat && headingSelector ? `${headingSelector} h1,
         ${headingSelector} h2,
         ${headingSelector} h3,
         ${headingSelector} h4,
         ${headingSelector} h5,
         ${headingSelector} h6 {
           font-family: '${displayName}', ${DEFAULT_FONT_FAMILY};
         }` : "";
  const displayFontFamily = validDisplayFont && displayFormat ? `'${displayName}', ${DEFAULT_FONT_FAMILY}` : void 0;
  const bodyFontFamily = validBodyFont && bodyFormat ? `'${bodyName}', ${DEFAULT_FONT_FAMILY}` : void 0;
  const fontFamily = bodyFontFamily ?? displayFontFamily;
  const seen = /* @__PURE__ */ new Set();
  const fontsToPreload = [];
  for (const f of [validDisplayFont, validBodyFont]) {
    if (f && !seen.has(f.url)) {
      seen.add(f.url);
      fontsToPreload.push({ url: f.url, contentType: getFontMimeType(f.contentType, f.url) });
    }
  }
  return {
    fontFaceCss: [displayFace, bodyFace, headingRule].filter(Boolean).join("\n"),
    fontFamily,
    displayFontFamily,
    bodyFontFamily,
    fontsToPreload
  };
};

export {
  isFontAsset,
  getFontFormat,
  getFontMimeType,
  generateThemeFontStyles
};
//# sourceMappingURL=chunk-56ABSXR6.mjs.map